import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ButtonStyled,
  ButtonTextStyled,
  InputContainerStyled,
  LoginContainerStyled,
  LoginSectionStyled,
  Subtitle2Styled,
  TitleStyled,
} from '../../../pages/others/login/login.styles';

import LoginAPI from '../../../../services/API/others/LoginAPI';
import ToasterBox from '../../singleComponents/toaster/ToasterBox';
import InputLabelPassword from '../../textInputs/InputLabelPassword/InputLabelPassword';

export default function ResetSection() {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('Ops, um erro ocorreu.');
  const navigate = useNavigate();

  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get('reset_token');

  const showAllert = (numberMessage = 0, message = '') => {
    const messages = [
      'Ocorreu um erro, tente novamente!',
      'Um token válido deve ser inserido!',
      'As senhas digitadas não são identicas, tente novamente!',
      'Enviando solicitação de alteração de senha!',
      'Sua senha já foi criada. Se esqueceu, volte à tela de login e acesse "Recuperar Conta".',
    ];

    if (message) {
      setAlertMessage(message);
    } else {
      setAlertMessage(messages[numberMessage]);
    }

    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 4500);
  };

  const redirectToPage = (path) => {
    setTimeout(() => {
      navigate(path);
    }, 4500);
  };

  const handleSubmitLogin = () => {
    const submit = () => {
      if (token.length !== 11) {
        showAllert(1);
      } else if (newPassword !== newPasswordConfirm) {
        setNewPassword('');
        setNewPasswordConfirm('');
        showAllert(2);
      } else {
        const user = {
          reset_token: token,
          password: newPassword,
          password_confirmation: newPasswordConfirm,
        };
        LoginAPI.patchLoginResetPasswordWithToken({ user })
          .then((response) => {
            if (response.data.messages) {
              showAllert(0, response.data.messages);
            } else {
              showAllert(3);
            }
          })
          .then(() => redirectToPage('/'))
          .catch(() => {
            showAllert(4);
          });
      }
    };

    if (LoginAPI.verifyDomain()) {
      submit();
    }
  };

  return (
    <LoginContainerStyled>
      {showAlert && <ToasterBox message={alertMessage} />}
      <LoginSectionStyled>
        <TitleStyled variant="h1">Cadastrar nova senha</TitleStyled>
        <Subtitle2Styled variant="h5">
          Para recuperar sua conta, digite e confirme sua nova senha:
        </Subtitle2Styled>

        <InputContainerStyled>
          <InputLabelPassword
            autoComplete="new-password"
            required
            fullWidth
            label="Nova senha"
            value={newPassword}
            onChange={({ target }) => {
              setNewPassword(target.value);
            }}
          />
        </InputContainerStyled>
        <InputContainerStyled>
          <InputLabelPassword
            autoComplete="new-password"
            required
            fullWidth
            label="Confirmação de senha"
            value={newPasswordConfirm}
            onChange={({ target }) => {
              setNewPasswordConfirm(target.value);
            }}
          />
        </InputContainerStyled>
        <ButtonStyled
          fullWidth
          onClick={handleSubmitLogin}
          disabled={showAlert || !token || !newPassword || !newPasswordConfirm}
        >
          <ButtonTextStyled variant="h3">Cadastrar nova senha</ButtonTextStyled>
        </ButtonStyled>
      </LoginSectionStyled>
    </LoginContainerStyled>
  );
}
